import { useDispatch, useSelector } from "react-redux";
import FullModal from "../../components/modal/full.modal";
import { MDBModalBody } from "mdb-react-ui-kit";
import Col from "../../components/element/col";
import { FooterLogo, Logo } from "../../assets/images";
import Row from "../../components/element/row";
import Input from "../../components/element/input";
import Image from "../../components/element/image";
import Button from "../../components/element/button";
import Icon from "../../components/element/icon";
import { useEffect, useState } from "react";
import { closeLoginModal } from "../../redux/reducer/modal.reducer";
import useWindowDimension from "../../components/hook/use.window.dimension";
import { Form, Formik } from "formik";
import * as Yup from "yup";
import { showToast } from "../../helpers/show.toast";
import { handleCatchError } from "../../helpers/handle.catch.error";
import {
  getRole,
  getToken,
  getUserId,
  getUsername,
  login,
  sendOtp,
} from "../../redux/reducer/common.reducer";
import Code from "../../components/element/code";

export default function LoginModal() {
  const dispatch = useDispatch();
  const { isOpenLoginModal } = useSelector((state) => state.modal);
  const { loginLoading, sendOtpLoading } = useSelector((state) => state.common);

  const [firstSend, setFirstSend] = useState(true);
  const [countDown, setCountDown] = useState(null);
  const [countDownId, setCountDownId] = useState(null);

  const handleCloseLogin = () => {
    dispatch(closeLoginModal());
  };

  const handleBack = (setFieldValue) => {
    setFirstSend(true);
    setCountDown(0);
    setFieldValue("verification_code", "");
  };

  const loginForm = {
    username: "",
    verification_code: "",
    type: "login",
  };

  const loginSchema = Yup.object().shape({
    username: Yup.string()
      .matches(
        /^(0?(11\d{7,8}|1[0-9]\d{7}))$/,
        "Please enter a valid phone number"
      )
      .required("Username is required"),
    verification_code: Yup.string()
      .min(6, "OTP must be at least 6 characters")
      .required("OTP is required"),
  });

  const handleSubmit = (values, setFieldError) => {
    dispatch(
      login({
        ...values,
        username: `+60${values.username}`,
      })
    )
      .unwrap()
      .then((res) => {
        localStorage.setItem("role", res.data.role);
        localStorage.setItem("token", res.data.token);
        localStorage.setItem("user_id", res.data.id);
        localStorage.setItem("username", res.data.username);

        dispatch(getRole());
        dispatch(getToken());
        dispatch(getUserId());
        dispatch(getUsername());

        handleCloseLogin();
        showToast(
          `Welcome back ${res.data.username}!`,
          "Logged in successful.",
          "success"
        );
      })
      .catch((ex) => {
        handleCatchError(ex, setFieldError);
      });
  };

  const handleSendOtp = (values, setFieldValue, setFieldError) => {
    dispatch(
      sendOtp({
        username: `+60${values.username}`,
      })
    )
      .unwrap()
      .then((res) => {
        if (firstSend) {
          setFirstSend(false);
        }

        setFieldValue(values, values);

        if (countDown === null) {
          setCountDown(120);

          const timer = setInterval(() => {
            setCountDown((prevCountdown) => prevCountdown - 1);
          }, 1000);
          setCountDownId(timer);
        }
      })
      .catch((ex) => {
        handleCatchError(ex, setFieldError);
      });
  };

  const formatCountDown = (time) => {
    const minutes = String(Math.floor(time / 60)).padStart(2, "0");
    const seconds = String(time % 60).padStart(2, "0");
    return `${minutes}:${seconds}`;
  };

  useEffect(() => {
    if (countDown === 0) {
      clearInterval(countDownId);
      setCountDown(null);
    }
  }, [countDown, countDownId]);

  return (
    <FullModal
      staticBackdrop={true}
      show={isOpenLoginModal}
      close={handleCloseLogin}
      screenSize="xl"
      className="overflow-hidden"
      dialogClassName="login-modal-dialog"
      contentClassName="login-modal"
      content={
        <MDBModalBody>
          <Formik
            initialValues={loginForm}
            validationSchema={loginSchema}
            enableReinitialize={true}
            onSubmit={(values, { setFieldError }) => {
              handleSubmit(values, setFieldError);
            }}
          >
            {({ values, errors, setFieldValue, setFieldError }) => (
              <Form
                className={`login-form --${firstSend ? "otp" : "verify"} w-100`}
              >
                {!firstSend ? (
                  <>
                    <Row
                      className="_row login-header pointer"
                      onClick={() => handleBack(setFieldValue)}
                    >
                      <Icon
                        icon="iconamoon:arrow-down-2"
                        className="_svg back pointer"
                      />
                      <p className="_label back">Back</p>
                    </Row>
                    <Col className="v-flex gap-2">
                      <h2 className="_label login-title">Verify</h2>
                      <p className="_label login-subtitle">
                        Enter the 4-digit verification code sent to your number
                      </p>
                    </Col>
                    <Code name="verification_code" />
                    <p
                      className={`_label resend-code ${
                        sendOtpLoading
                          ? "--loading"
                          : countDown === null
                          ? "pointer"
                          : ""
                      }`}
                      onClick={() => {
                        if (countDown === null && !sendOtpLoading) {
                          handleSendOtp(values, setFieldValue, setFieldError);
                        }
                      }}
                    >
                      {countDown === null ? (
                        <>
                          Didn't get the code?&nbsp;&nbsp;
                          <span>{sendOtpLoading ? "Sending.." : "Resend"}</span>
                        </>
                      ) : (
                        <span>Resend in&nbsp;{formatCountDown(countDown)}</span>
                      )}
                    </p>
                    <Button
                      type="submit"
                      disabled={loginLoading}
                      className="_button verify"
                      // onClick={() => handleCloseLogin()}
                    >
                      <p>Verify</p>
                      {/* <Icon icon="iconamoon:arrow-down-2" /> */}
                    </Button>
                  </>
                ) : (
                  <>
                    <Row className="_row login-header">
                      <Image src={Logo} className="_img logo" />
                    </Row>
                    <Col className="v-flex gap-2">
                      <h2 className="_label login-title">Login</h2>
                      <p className="_label login-subtitle">
                        Get going with DC Fashion
                      </p>
                    </Col>
                    <Row className="_row phone-frame">
                      <p className="_label phone-code">+60</p>
                      <Input name="username" invalid={false} />
                    </Row>
                    {errors.username && (
                      <Row className="_label error-message element _errors">
                        {errors.username}
                      </Row>
                    )}
                    <Button
                      className="_button"
                      disabled={
                        !values.username || errors.username || sendOtpLoading
                      }
                      onClick={() => {
                        if (countDown === null) {
                          handleSendOtp(values, setFieldValue, setFieldError);
                        }
                      }}
                    >
                      <p>{sendOtpLoading ? "Sending.." : "Send OTP"}</p>
                      <Icon icon="iconamoon:arrow-down-2" />
                    </Button>
                  </>
                )}
              </Form>
            )}
          </Formik>
        </MDBModalBody>
      }
    />
  );
}
